import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import StaffForm from "./StaffForm";
import { addStaffApi } from "../../api/staffService";
const AddStaff = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const userId = localStorage.getItem("userId");
  const handleAdd = async (formData) => {
    try {
      setLoading(true);
      await addStaffApi(formData);
      navigate("/staff");
    } catch (error) {
      console.log("Add Staff Error:", error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="container mt-4">
      <StaffForm
        onSubmit={handleAdd}
        loading={loading}
        userId={userId}
      />
    </div>
  );
};
export default AddStaff;